import { getApiConfig } from "../../../settings/api";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect, SelectEffect, select } from "redux-saga/effects";
import { ReducersTypes } from "@/redux/reducers/Models";
import { resolveSourceChannel } from "@/hooks/useTheme";
import { getThemeFromStorage } from "@/contexts/ThemeContext";

export interface Fetch {
  plate: string;
  callback: (success: boolean, code?: string) => void;
}

export interface RequestDebtsAction {
  type: string;
  payload: Fetch;
}

export default function* requestDebts({
  payload,
}: RequestDebtsAction): Generator<
  CallEffect<unknown> | PutEffect<Action> | SelectEffect,
  void,
  AxiosResponse
> {
  try {
    const getCustomer = (state: ReducersTypes) => state.customerReducer;
    const getUser = (state: ReducersTypes) => state.userReducer;
    // @ts-expect-error
    const customer: ReducersTypes["customerReducer"] =
      yield select(getCustomer);
    // @ts-expect-error
    const user: ReducersTypes["userReducer"] = yield select(getUser);
    const isLogged = Boolean(customer?.accessToken);

    const sourceChannel = resolveSourceChannel({
      location:
        typeof window !== "undefined"
          ? {
              hash: window.location.hash,
              search: window.location.search,
              pathname: window.location.pathname,
            }
          : undefined,
      storedTheme:
        typeof window !== "undefined" ? getThemeFromStorage() : undefined,
      company: user?.company,
    });
    const data = { licensePlate: payload.plate, sourceChannel };
    const { apiInstance, prefixUri } = getApiConfig(isLogged);
    const response = yield call(
      apiInstance.post,
      `${prefixUri}/v1/vehicle-debts/start`,
      data,
    );

    if (response?.data?.data) {
      yield call(payload.callback, true, response?.data?.data);
    } else {
      yield call(payload.callback, false, "error");
    }
  } catch (error) {
    yield call(payload.callback, false, "timeout");
  }
}
